
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Games from "../pages/games/page";
import Progress from "../pages/progress/page";
import SnakesLadders from "../pages/game/snakes-ladders/page";
import Login from "../pages/auth/login/page";
import CreateInvite from "../pages/auth/invite/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import WordPuzzle from "../pages/game/word-puzzle/page";
import WhiteboardList from "../pages/whiteboard/page";
import WhiteboardEditor from "../pages/whiteboard/editor/[id]/page";

const routes: RouteObject[] = [
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/invite",
    element: (
      <ProtectedRoute>
        <CreateInvite />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/games",
    element: (
      <ProtectedRoute>
        <Games />
      </ProtectedRoute>
    ),
  },
  {
    path: "/progress",
    element: (
      <ProtectedRoute>
        <Progress />
      </ProtectedRoute>
    ),
  },
  {
    path: "/whiteboard",
    element: (
      <ProtectedRoute>
        <WhiteboardList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/whiteboard/:id",
    element: (
      <ProtectedRoute>
        <WhiteboardEditor />
      </ProtectedRoute>
    ),
  },
  {
    path: "/game/snakes-ladders",
    element: (
      <ProtectedRoute>
        <SnakesLadders />
      </ProtectedRoute>
    ),
  },
  {
    path: "/game/word-puzzle",
    element: (
      <ProtectedRoute>
        <WordPuzzle />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
